import { useState, useEffect } from 'react'
import { HomePage, LoginPage, AdminReminderPage, AuthCallback } from '@/pages'

interface Route {
  path: string
  component: () => JSX.Element
  exact?: boolean
}

const routes: Route[] = [
  {
    path: '/auth/callback',
    component: () => <AuthCallback />,
    exact: true
  },
  {
    path: '/login',
    component: () => <LoginPage />,
    exact: true
  },
  {
    path: '/admin/reminders',
    component: () => <AdminReminderPage />,
    exact: true
  },
  {
    path: '/',
    component: () => <HomePage />,
    exact: true
  }
]

export function Router() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname)

  useEffect(() => {
    const handlePopState = () => {
      setCurrentPath(window.location.pathname)
    }

    window.addEventListener('popstate', handlePopState)
    return () => window.removeEventListener('popstate', handlePopState)
  }, [])

  const navigate = (path: string, replace: boolean = false) => {
    if (replace) {
      window.history.replaceState({}, '', path)
    } else {
      window.history.pushState({}, '', path)
    }
    setCurrentPath(path)
  }

  const findRoute = () => {
    for (const route of routes) {
      if (route.exact && route.path === currentPath) {
        return route
      }
    }

    for (const route of routes) {
      if (!route.exact && currentPath.startsWith(route.path)) {
        return route
      }
    }

    return routes.find(route => route.path === '/')
  }

  const matchedRoute = findRoute()

  if (!matchedRoute) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center" dir="rtl">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 font-hebrew mb-4">
            עמוד לא נמצא
          </h1>
          <p className="text-gray-600 font-hebrew mb-4">
            הקישור שחיפשת לא קיים במערכת
          </p>
          <button 
            onClick={() => navigate('/')}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 font-hebrew"
          >
            חזור לעמוד הראשי
          </button>
        </div>
      </div>
    )
  }

  return <matchedRoute.component />
}

export { RouterUtils } from '@/utils/routerUtils'